export default __webpack_public_path__ + "static/media/new_subscriber1.dfadf3e8.png";